import React from 'react';
import { HiOutlineTruck } from 'react-icons/hi2';
import Icon from '../../utils/Icon';
import { NoteWrapper, NoteIcon, NoteText } from './styles';

export const FRETE_FIXO = 10;

interface FreteNoteProps {
  variant?: 'hero' | 'footer';
}

const FreteNote: React.FC<FreteNoteProps> = ({ variant = 'footer' }) => {
  return (
    <NoteWrapper $variant={variant}>
      <NoteIcon $variant={variant} aria-hidden="true">
        <Icon icon={HiOutlineTruck} />
      </NoteIcon>
      <NoteText $variant={variant}>
        Frete fixo de R$&nbsp;{FRETE_FIXO.toFixed(2).replace('.', ',')} para a cidade de Muriaé.
      </NoteText>
    </NoteWrapper>
  );
};

export default FreteNote;
